module.exports = __webpack_public_path__ + "img/jwlsct.d34cb20b.png";